import { gql } from '@/service/gql'
import { type SanitizedResult } from '@amzn/amp-gql'

/**
 * Party-specific queue wire. The shared cloud-queue view read + remove / reorder
 * mutations live in `cloudQueue/queueViewService.ts`; this module owns only the
 * Hermes push that guest edits ride on.
 */

// language=GraphQL
//
// Hermes subscription — fires whenever the host's CloudQueue
// changes (guests add or remove tracks). The push payload is tiny
// (just the queue id) — the controller re-fetches the queue view
// via the http path on each event so the rest of the codebase keeps
// using the same queue-state model.
export const queueUpdatedSubscription = gql(`
  subscription QueueUpdated($queueId: String!) {
    queueUpdated(queueId: $queueId) {
      id
    }
  }
`)

export type QueueUpdatedResult = SanitizedResult<typeof queueUpdatedSubscription>
